"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORBIDDEN_CODE = exports.ERROR_MESSAGE = exports.HEADER_NAME = exports.SECRET_NOT_FOUND_ERROR_MESSAGE = exports.SECRET_MANAGER_ERROR_MESSAGE = exports.CSRF_HMAC_SECRET_NAME = exports.SECRET_ENV_NAME = exports.EB_UI_COOKIE_NAME = exports.COOKIE_NAME = void 0;
exports.COOKIE_NAME = "CSRF-TOKEN";
exports.EB_UI_COOKIE_NAME = "csrftoken";
exports.SECRET_ENV_NAME = "CSRF_HMAC_SECRET";
exports.CSRF_HMAC_SECRET_NAME = "CsrfHmacSecret";
exports.SECRET_MANAGER_ERROR_MESSAGE = "Failed to retrieve CSRF HMAC secret from Secret Manager";
exports.SECRET_NOT_FOUND_ERROR_MESSAGE = "Failed to fetch CSRF HMAC secret value";
// Using same Header names as in Core in order to be able to call apiV3 endpoints
exports.HEADER_NAME = "X-CSRFToken";
exports.ERROR_MESSAGE = "Forbidden: missing or invalid csrf token";
exports.FORBIDDEN_CODE = 403;
//# sourceMappingURL=constants.js.map